<div class="user-image-container">
  @if (userImage$ | async; as userImage) {
  <img [src]="userImage" class="user-photo" />
  } @else {
  <mat-icon class="user-photo-placeholder">person</mat-icon>
  }
</div>
<div class="comment-wrapper">
  <div class="comment-header">
    <div class="comment-info">
      @if (userProfile$ | async; as userProfile) {
      <div>{{ userProfile?.displayName }}</div>
      }
      <div class="date">
        Commented on {{ comment.createdAt.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) }}
      </div>
    </div>
    @if (editDeleteAllowed) {
    <div class="edit-delete">
      @if (!editModeActive) {
      <div>
        <button class="iconf-btn-blank minw100" (click)="toggleEdit()">
          <mat-icon>edit</mat-icon>
          edit
        </button>
      </div>
      } @else {
      <button class="iconf-btn-blank minw100" (click)="toggleEdit()">
        <mat-icon>edit</mat-icon>
        cancel
      </button>
      }
      <div>
        <button class="iconf-btn-blank minw100" (click)="deleteComment()">
          <mat-icon>delete</mat-icon>
          delete
        </button>
      </div>
    </div>
    }
  </div>
  @if (editModeActive) {
  <div>
    <div class="edit-comment">
      <textarea #editContent class="textarea" type="text">{{ comment.content }}</textarea>
      <div class="edit-comment-button">
        <button (click)="editComment(editContent.value)" class="iconf-btn-filled minw150 margin-border minh40">save</button>
      </div>
    </div>
  </div>
  } @else {
  <div class="content">
    {{ comment.content }}
  </div>
  }
</div>
